import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthLayout } from "@/components/app/AuthLayout";
import { TextField, PrimaryButton } from "@/components/app/TextField";
import { authApi, apiError } from "@/lib/api";
import { AUTH } from "@/constants/testIds";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Hasło musi mieć co najmniej 8 znaków.");
    if (password !== confirm) return setError("Hasła nie są identyczne.");
    setLoading(true);
    try {
      await authApi.reset(token, password);
      setDone(true);
    } catch (err) {
      setError(apiError(err.response?.data?.detail, err.message));
    } finally {
      setLoading(false);
    }
  };

  const missingToken = !token;

  return (
    <AuthLayout
      title="Ustaw nowe hasło"
      subtitle={missingToken ? "Brak tokenu resetu w adresie." : "Wpisz nowe hasło do swojego konta."}
      footer={
        <Link to="/logowanie" data-testid={AUTH.loginLink} className="font-medium text-brand-accent hover:underline">
          Przejdź do logowania
        </Link>
      }
    >
      {done ? (
        <div data-testid={AUTH.success} className="rounded-field border border-brand-line bg-brand-surface px-4 py-4 text-sm text-brand-sec">
          Hasło zostało zmienione. Możesz się teraz zalogować.
        </div>
      ) : missingToken ? (
        <div data-testid={AUTH.error} className="rounded-field border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-300">
          Link resetu jest nieprawidłowy. Poproś o nowy na stronie „Nie pamiętam hasła”.
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4" noValidate>
          {error && (
            <div data-testid={AUTH.error} className="rounded-field border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-300">
              {error}
            </div>
          )}
          <TextField label="Nowe hasło" type="password" testId={AUTH.passwordInput} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Minimum 8 znaków" autoComplete="new-password" required />
          <TextField label="Powtórz nowe hasło" type="password" testId={AUTH.passwordConfirmInput} value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Powtórz hasło" autoComplete="new-password" required />
          <PrimaryButton type="submit" data-testid={AUTH.submitButton} disabled={loading}>
            {loading ? "Zapisywanie…" : "Zapisz nowe hasło"}
          </PrimaryButton>
        </form>
      )}
    </AuthLayout>
  );
}
